import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

const Button = ({ href, onClick, fullWidth = false, target = '', typeButton, ...props }) =>
  !onClick && !typeButton && !props.isSubmit ? (
    <Link
      href={href}
      target={target}
      className={cn('mx-auto inline-block', { 'md:w-full ': fullWidth })}
    >
      <Anchor fullWidth={fullWidth} {...props} />
    </Link>
  ) : (
    <button
      type={props.isSubmit ? 'submit' : 'button'}
      className={cn('mx-auto inline-block', typeButton?.className, { 'md:w-full': fullWidth })}
      onClick={onClick}
      id={typeButton?.id}
    >
      <Anchor fullWidth={fullWidth} {...props} />
    </button>
  );

const textArrow = text => (
  <>
    <span className="text underline-offset-2 hover:underline-offset-4 transition-all duration-[400ms]">
      {text}
    </span>{' '}
    <span className="inline-block w-fit ml-1 font-normal transition-all duration-[400ms] transform group-hover:translate-x-1 font-unicode">
      →
    </span>
  </>
);

const Anchor = ({ text, variant, type, size, fullWidth, hideArrow }) => {
  const buttonSize = {
    small: type === 'primary' ? 'text-sm px-4 py-1 leading-6' : 'text-sm py-1',
    medium: type === 'primary' ? 'text-base px-4 py-2 leading-[150%]' : 'text-base py-2'
  };

  return (
    <div
      className={cn(
        buttonType[type][variant],
        buttonSize[size],
        'font-medium justify-center flex flex-nowrap rounded-full whitespace-nowrap transition-all duration-[400ms] cursor-pointer group items-center h-full group leading-[150%] hover:brightness-75',
        { 'md:w-full text-center': fullWidth }
      )}
    >
      {!hideArrow ? textArrow(text) : text}
    </div>
  );
};

const buttonType = {
  primary: {
    default: 'text-white bg-scale-mauve hover:bg-[#A672A2]',
    black: 'text-white bg-black hover:brightne ss-75',
    'black-transparent': 'text-white bg-black/60 hover:bg-brightness-75',
    'white-transparent': 'text-white bg-white/20 hover:bg-white/30',
    grayscale: 'text-black bg-white hover:bg-[#FBFBFB]',
    blue: 'text-white bg-scale-periwinkle hover:bg-[#6B80D2]'
  },
  secondary: {
    default: 'text-white',
    black: 'text-black',
    'black-transparent': 'text-black',
    'white-transparent': 'text-white',
    underlined: '[&>.text]:underline text-white !pl-0'
  }
};

Button.defaultProps = {
  text: 'Get Started',
  href: 'https://dashboard.scale.com/signup',
  type: 'primary',
  variant: 'default',
  size: 'medium',
  hideArrow: false,
  onClick: null,
  isSubmit: false
};

export default Button;
